import { BREAKPOINT_LARGE, BREAKPOINT_MED, HTML_WIDTH } from '../variables';
import { addCartQuantityBtnHandlers } from './cart';
import { addHtmlToColorChoiceProducts, productBundlePriceProdlist, productBundleSkuProdulist } from './product-list';
import { bundleFunctionality, updateBundleProductsStockHtml } from './product-page-modules/bundle-item-functionality';
import { triggerChangeIfSizeInQueryParams, variationFunctionality } from './product-page-modules/varitation-item-functionality';

export default function productPageFunctionality() {
  if (!document.querySelector('.single-product'))
    return;

  addProductQuantityBtns();
  moveWeight();
  moveDimensions();
  getProductDeliveryPlan();
  addDummyBuyButton();
  mobileProductPage();
  hideOutOfStockText();
  productImgActiveBtn();
  productImgActive();
  constructCustomUpsellHtml();
  insertCustomUpsellInDom();
  addCustomUpsellClickHandlers();
  singleProductPage(); // TODO Riv ut innehållet ur denna
  wrapRelatedProductsInContainer();
  addLinkFunctionalityToProductPDFs();
  productBundleSkuProdulist();
  productBundlePriceProdlist();
  preventImageChangeFromVariationImage();
  displayFabricCategories();
  checkForEmptyFabricCategories();
  addShowMoreFunctionalityToDisplayProducts();
  observeChangesOnDescriptionEl();
  addHtmlToColorChoiceProducts();
  initLightboxForVariationImages();

  // mobileAndTabletFunctionality();

  if (productInformationObj.type === 'variable')
    variationFunctionality();

  if (productInformationObj.type === 'bundle')
    bundleFunctionality();
}

// ********************************************
// ***************** GENERAL ******************
// ********************************************

function addLinkFunctionalityToProductPDFs() {
  // Länkar som ligger inuti tabbar är inte klickbara utan detta
  $('.product-attachment-link').on('click', function () {
    if ($(this).attr('data-href').length > 0) {
      window.location.href = $(this).attr('data-href');
    }
  });
}

function addProductQuantityBtns() {
  if (HTML_WIDTH >= BREAKPOINT_LARGE) {
    $('form.cart .quantity > .qty').attr('type', 'text').parent().append('<span class="increase-product-qty">+</span>').prepend('<span class="decrease-product-qty">-</span>');
    addCartQuantityBtnHandlers();
  }
}

function moveDimensions() {
  if ($('.product-dimensions').length > 0) {
    $('.product-dimensions').insertAfter('.product-meta');
    $('.product-dimensions').addClass('wl-moved');
  }

  if ($('.hidden-dimensions').length > 0) {
    $('.hidden-dimensions').insertAfter('.product-meta');
    $('.hidden-dimensions').addClass('wl-moved');
  }
}

function moveWeight() {
  if ($('.product-weights').length > 0) {
    $('.product-weights').insertAfter('.product-meta');
    $('.product-weights').addClass('wl-moved');
  }

  if ($('.hidden-weights').length > 0) {
    $('.hidden-weights').insertAfter('.product-meta');
    $('.hidden-weights').addClass('wl-moved');
  }
}

function toggleProductPageSelects(toBeDisabled) {
  for (const selectEl of [...document.querySelectorAll('select')]) {
    if (toBeDisabled)
      selectEl.setAttribute('disabled', true);
    else
      selectEl.removeAttribute('disabled');
  }
}

// För att ändra kategorin på en singelprodukt
function displayFabricCategories() {
  let changeCategoryTitle = false;
  let isSwedish = true;

  if (document.documentElement.lang == 'sv-SE') {
    if ($('.product-category-list').text() == 'Tyg') {
      changeCategoryTitle = true;
    }
  } else {
    if ($('.product-category-list').text() == 'Fabric') {
      changeCategoryTitle = true;
      isSwedish = false;
    }
  }

  if (changeCategoryTitle) {
    let parseArtNoStr = $('.sku').first().text();
    if (parseArtNoStr.length > 0) {
      // Kolla om det är en kategori 10
      if (parseArtNoStr.substring(0, 3) == 'T10') {
        if (isSwedish) {
          $('.product-category-list').text('Tyg Kat. 10');
        } else {
          $('.product-category-list').text('Fabric Cat. 10');
        }
      } else {
        parseArtNoStr = parseArtNoStr.substring(1, 2);
        // Annars fortsätt som vanligt, hoppas dom har formen TXxxx-xx
        if (isSwedish) {
          $('.product-category-list').text('Tyg Kat. ' + parseArtNoStr);
        } else {
          $('.product-category-list').text('Fabric Cat. ' + parseArtNoStr);
        }
      }
    }
  }
}

function checkForEmptyFabricCategories() {
  const fabricContainer = document.querySelector('.attribute-select.fabric');

  if (!fabricContainer)
    return;

  const fabricChoices = [...fabricContainer.querySelectorAll('.single-choice')];

  for (const fabricChoice of fabricChoices) {
    if (!fabricChoice.querySelector('.multiple-choice'))
      fabricChoice.classList.add('-is-empty');
  }
}

function addDummyBuyButton() {
  if ($('body').hasClass('guest'))
    return;

  const buttonString = '<button disabled name="add-to-cart" class="single_add_to_cart_button dummy">Lägg i varukorg</button>';
  if ($('.single_add_to_cart_button').length == 0) {
    if ($('.tinv-wraper').length > 0)
      $('.tinv-wraper').addClass('no-stock-product');

    if ($('.product').hasClass('product-type-simple') && $('.cart').length == 0)
      $('.summary').append(buttonString);

    if ($('.product').hasClass('product-type-variable'))
      $('.cart').append(buttonString);

    if ($('.bundle_out_of_stock').length == 1) {
      $('.bundle_data', '.bundle_form').append(buttonString);
      $('.bundle_wrap').css('display', 'none');
    }
  }
}

function preventImageChangeFromVariationImage() {
  // Hindra variationsbild fråm att ersätta produktbild
  $('.wp-post-image').removeClass('wp-post-image'); // Hackig lösning från way back...
}

function mobileProductPage() {
  if (HTML_WIDTH >= BREAKPOINT_MED)
    return;

  if ($('.cart .tinv-wraper').length) {
    $('.cart .tinv-wraper').addClass('mobile-favorite-button').insertAfter($('.product-category-list'));
    $('.product-meta .product-sku').insertAfter($('.product_title.entry-title'));
  }

  if ($('body').hasClass('single-product') && $('.single_add_to_cart_button.dummy').length) {
    $('.summary .tinv-wraper').addClass('mobile-favorite-button').insertAfter($('.product-category-list'));
    $('.product-meta .product-sku').insertAfter($('.product_title.entry-title'));
  }
}

function hideOutOfStockText() {
  if (typeof isNonStockItem !== 'undefined' && isNonStockItem) {
    $('.out-of-stock').css('display', 'none');
  }
}

function productImgActiveBtn() {
  let src;

  $('.single-product-images .woocommerce-product-gallery__wrapper .woocommerce-product-gallery__image').each(function () {
    if ($(this).hasClass('flex-active-slide')) {
      src = $('a img', this).attr('src');
    }
  });

  $('.single-product-images .product-thumbnails-container .woocommerce-product-gallery__image').each(function () {
    const thumbSrc = $('a img', this).attr('src');
    $(this).removeClass('custom-active custom-not-active');
    if (thumbSrc === src) {
      $(this).addClass('custom-active');
    } else {
      $(this).addClass('custom-not-active');
    }
  });
}

function productImgActive() {
  if ($('.single-product .single-product-images .product-thumbnails-container .woocommerce-product-gallery__image').length > 1) {
    let src;
    $('.single-product-images .woocommerce-product-gallery__wrapper .woocommerce-product-gallery__image').each(function () {
      if ($(this).hasClass('flex-active-slide')) {
        src = $('a img', this).attr('src');
      }
    });
    $('.single-product-images .product-thumbnails-container .woocommerce-product-gallery__image').each(function () {
      const thumbSrc = $('a img', this).attr('src');
      $(this).removeClass('custom-active custom-not-active');
      if (thumbSrc === src) {
        $(this).addClass('custom-active');
      } else {
        $(this).addClass('custom-not-active');
      }
    });
    $('.single-product-images .flex-direction-nav .flex-nav-prev').click(function () {
      productImgActiveBtn();
    });
    $('.single-product-images .flex-direction-nav .flex-nav-next').click(function () {
      productImgActiveBtn();
    });
  }
}

function observeChangesOnDescriptionEl() { // Om någon metod ändrar innehållet i product-description, se till så att vi rensar bort allt efter read-more-taggen
  const observer = new MutationObserver(handleMutation);
  const target = document.querySelector('.product-description');

  if (!target)
    return;

  const config = {
    childList: true,
    subtree: true,
    characterData: true
  };

  observer.observe(target, config);

  function handleMutation(mutations) {
    for (const mutation of mutations) {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        checkForMorecontentLinks();
        clearDescriptionAfterReadMoreTag();
      }
    }
  }
}

function constructCustomUpsellHtml() {
  let upsellsHtml = '';
  $('.up-sells .products li').each(function () {
    const href = $('a', this).attr('href');
    const imgSrc = $('img', this).attr('src');
    const colorDesc = $('.wl-hidden-product-data', this).data('colorDesc');

    upsellsHtml += '<div class="woocommerce-product-gallery__image custom-upsell"><a href="' + href + '">' + (colorDesc ? '<figcaption class="wl-color-description__text">' + colorDesc + '</figCaption>' : '') + '<img src="' + imgSrc + '"></a></div>';
  });

  return upsellsHtml;
}

function insertCustomUpsellInDom(upsellsHtml) {
  // Ursprungligen ville kunden att upsells skulle in efter första bilden i thumbnails
  // men funktionaliteten blir fruktansvärd då så jag tar bort det // David
  $('.product-thumbnails').append(upsellsHtml);
}

function addCustomUpsellClickHandlers() {
  $('.custom-upsell a').on('click', function (e) {
    if (HTML_WIDTH > BREAKPOINT_LARGE) {
      window.location.href = $(this).attr('href');
      return;
    }

    // I Mobil eller tablet
    e.preventDefault();
    const colorDescriptionEl = this.querySelector('.wl-color-description__text');

    const allColorDescriptionEls = [...document.querySelectorAll('.wl-color-description__text')];

    for (const descriptionEl of allColorDescriptionEls) {
      if (descriptionEl !== colorDescriptionEl)
        descriptionEl.classList.remove('-showing');
    }

    if (!colorDescriptionEl) {
      window.location.href = $(this).attr('href');
      return;
    }

    if (colorDescriptionEl.classList.contains('-showing'))
      window.location.href = $(this).attr('href');
    else
      colorDescriptionEl.classList.add('-showing');
  });
}

function rebuildUpSells() {
  if (!$('.up-sells').length)
    return;

  setTimeout(() => {
    const htmlString = constructCustomUpsellHtml();
    insertCustomUpsellInDom(htmlString);
    addCustomUpsellClickHandlers();
    changeProductGalleryImageLinks();
    addUpSellProducts();
  }, 100);
}

function changeProductGalleryImageLinks() {
  $('.woocommerce-product-gallery__image.custom-upsell > a').each(function (index) {
    $('.upsell-image').eq(index).parent().attr('href', $(this).attr('href'));
  });
}

function addUpSellProducts() {
  if ($('.woocommerce-product-gallery__image.custom-upsell').length && $('#wl-product-extra-information .wl-product-information__content').length) {
    let upsellHeader = 'Fler utföranden';
    let upSellProductsHTML = '';
    if ($('html').attr('lang') == 'en-US') {
      upsellHeader = 'More designs';
    }
    $('.woocommerce-product-gallery__image.custom-upsell').each(function () {
      const thisProductHTML = $(this).html();
      upSellProductsHTML += `<div class="single-upsell">
                              ${thisProductHTML}
                            </div>`;
    });
    const upsell = `<section class="wl-product-information__section wl-product-information__upsell">
                    <button class="show-product-information-btn wl-down-arrow-btn --skinny btn-reset"></button>
                    <h3>${upsellHeader}</h3>
                    <div class="section-content___container">
                      <div class="section__content">
                        ${upSellProductsHTML}
                    </div>
                    </div>
                  </section>`;
    if ($('.wl-production-information__print-btn-container').length) {
      $('.wl-production-information__print-btn-container').before(upsell);
    } else {
      if ($('#wl-product-extra-information .wl-product-information__content .wl-product-information__section').length) {
        $('#wl-product-extra-information .wl-product-information__content .wl-product-information__section:last-child').after(upsell);
      } else {
        $('.wl-product-information__content').append(upsell);
      }
    }

    const productInformationUpsellBtn = document.querySelector('.wl-product-information__upsell');

    if (!productInformationUpsellBtn)
      return;

    const allProductInformationToggleBtns = [...productInformationUpsellBtn.querySelectorAll('.show-product-information-btn')];

    for (const toggleBtn of allProductInformationToggleBtns) {
      toggleBtn.addEventListener('click', function (e) {
        e.target.parentNode.classList.toggle('--is-open');
        e.target.parentNode.querySelector(':scope .wl-down-arrow-btn').classList.toggle('--is-active');
      });
    }
  }
}

// Vi ska aldrig visa innehåll efter läs-mer-taggen så rensa denna ifall det finns något.
// Lägger man ut Läs-mer på rätt sätt kommer css-en dölja all text efter men den går fan inte lita på
export function clearDescriptionAfterReadMoreTag() {
  const contentParent = document.querySelector('.product-description .more-content__parent');
  const pattern = /(?:<span id=(["'])more-\d+\1><\/span>)/gm;

  if (!contentParent)
    return;

  if (contentParent.innerHTML === contentParent.innerHTML.split(pattern, 1)[0])
    return;

  contentParent.innerHTML = contentParent.innerHTML.split(pattern, 1)[0]; // ska vara safe, om ingen träff på pattern har vi index 0 som ursprungsinnehållet
}

function singleProductPage() {
  if (typeof productInformationObj !== 'undefined' && productInformationObj?.id) {
    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'get_upsell',
        global_id: productInformationObj.id
      },
      success: function (upsells) {
        $('.wl-container').append('<section class="up-sells"><div class="products"></div></section>');
        $('.up-sells .products').append($(upsells).html());

        rebuildUpSells();
      }
    });
  } else {
    rebuildUpSells();
  }

  initFlexSliderFunctionality();
  addShowExtraProductInformationFunctionality();
  // initCarpetConfigurator();

  $('.woocommerce-product-gallery').after($('.product-thumbnails-container'));
  $('.product-thumbnails-container').show();

  const itemDimensions = $('tr.woocommerce-product-attributes-item.woocommerce-product-attributes-item--dimensions > td').text();
  $('.woocommerce-product-details__short-description').after('<div class="dimensions">' + itemDimensions + '</div>');

  // länka thumbnails tlll rätt bild i slidern
  $('.product-thumbnails > div').click(function (e) {
    e.preventDefault();
    const liParent = $('.flex-control-paging li').eq($(this).index());
    $('a', liParent).click();
  });
  $('.wc-tabs > li').each(function () {
    if ($(this).hasClass('active')) {
      $(this).toggleClass('active');
      $('div', this).toggle();
    }
  });

  $('.wc-tabs > li').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).toggleClass('active');
    $('div', this).toggle();
  });

  // Gör köpknappen 100% när favoritstjärnan är borta
  if (!$('body').hasClass('logged-in')) {
    moveResellerLink();
    $('.tinv-wraper').hide();
    setTimeout(function () {
      $('.single_add_to_cart_button').css({
        width: '100%',
        'margin-left': '0'
      });
    }, 100);
  }

  function moveResellerLink() {
    const resellerLink = document.getElementById('guest-reseller-link');

    if (!resellerLink)
      return;

    if (resellerLink.classList.contains('bundle')) {
      const bundleDataEl = document.querySelector('.cart.bundle_data');

      if (bundleDataEl) {
        bundleDataEl.before(resellerLink);
        resellerLink.classList.add('wl-moved');
      }
    }

    if (resellerLink.classList.contains('variable')) {
      const variationWrapEl = document.querySelector('.single_variation_wrap');

      if (variationWrapEl) {
        variationWrapEl.before(resellerLink);
        resellerLink.classList.add('wl-moved');
      }
    }
  }

  function addShowExtraProductInformationFunctionality() {
    checkForMorecontentLinks();
    clearDescriptionAfterReadMoreTag();

    const showExtraInfoBtn = document.getElementById('wl-show-extra-information-btn');
    const showExtraInformationContainer = document.getElementById('wl-product-extra-information');
    const extraInformationOverlay = document.getElementById('wl-product-information__overlay');
    const productInformationPrintBtn = document.getElementById('print-product-information-btn');

    if (!showExtraInfoBtn || !showExtraInformationContainer || !extraInformationOverlay)
      return;

    const allProductInformationToggleBtns = [...showExtraInformationContainer.querySelectorAll('.show-product-information-btn')];

    for (const toggleBtn of allProductInformationToggleBtns) {
      toggleBtn.addEventListener('click', function (e) {
        e.target.parentNode.classList.toggle('--is-open');
        e.target.parentNode.querySelector(':scope .wl-down-arrow-btn').classList.toggle('--is-active');
      });
    }

    showExtraInfoBtn.addEventListener('click', function () {
      showExtraInformationContainer.classList.toggle('-is-active');
    });

    extraInformationOverlay.addEventListener('click', function () {
      showExtraInformationContainer.classList.toggle('-is-active');
    });

    productInformationPrintBtn.addEventListener('click', function () {
      window.print();
    });
  }

  // Funktionalitet för att kunna byta sida om det dyker upp en bild som tillhör annan produkt
  function initFlexSliderFunctionality() {
    if (!$('.woocommerce-product-gallery .flex-viewport').length)
      return;

    attachFlexSliderClickHandlers();
  }

  function attachFlexSliderClickHandlers() {
    $('.woocommerce-product-gallery .flex-next, .woocommerce-product-gallery .flex-prev').click(function () {
      // Denna slår alltid i rätt tid nu men kan vara värt att tänka på ifall det börjar strula.
      // När sätter flexslidern active-klassen?
      const currentSlide = $('.woocommerce-product-gallery__image.flex-active-slide');
      const imageHref = $('> a', currentSlide).attr('href');

      if (!imageHref.includes('wp-content')) {
        // Länkar vidare ifall det är en extraprodukt..
        window.location.href = imageHref;
      }
    });
  }
}

export function checkForMorecontentLinks() {
  const moreContentBtns = document.querySelectorAll('.product-description span[id^=more]'); // Finns f. En på produkten och en i content som slajdar ut

  if (moreContentBtns.length === 0)
    return false;

  for (const moreContentBtn of moreContentBtns) {
    if (!moreContentBtn.parentElement.classList.contains('more-content__parent'))
      moreContentBtn.parentElement.classList.add('more-content__parent');
  }

  return true;
}

function wrapRelatedProductsInContainer() { // Guuuuuud varför gör jag detta?? Har iaf byggt om det så vi sparar alla attribut nu.
  const relatedListEls = document.querySelectorAll('.related .products li');

  for (const relatedProduct of relatedListEls) {
    const divEl = document.createElement('div');
    divEl.className = 'related-item';
    divEl.innerHTML = relatedProduct.innerHTML;

    if (!relatedProduct.attributes)
      continue;

    const attributes = [...relatedProduct.attributes];

    for (const attribute of attributes) {
      divEl.setAttribute(attribute.name, attribute.value);
    }

    relatedProduct.parentNode.replaceChild(divEl, relatedProduct);
  }
}

function showHideLoadMoreDisplayProductsBtn(showMoreDisplayProductsBtn, displayProductsContainer) {
  const allDisplayProducts = [...displayProductsContainer.querySelectorAll('.product')];

  let showButtonIfMorethanProducts = 8;

  if (HTML_WIDTH <= 768) {
    showButtonIfMorethanProducts = 4;
  } else if (HTML_WIDTH > 768 && HTML_WIDTH < 1024) {
    showButtonIfMorethanProducts = 6;
  }

  if (allDisplayProducts.length > showButtonIfMorethanProducts)
    showMoreDisplayProductsBtn.style.display = 'block';
  else
    showMoreDisplayProductsBtn.style.display = 'none';
}

function addShowMoreFunctionalityToDisplayProducts() {
  const showMoreDisplayProductsBtn = document.getElementById('load-more-display-products-btn');
  const displayProductsContainer = document.querySelector('.wl-display-products');

  if (!showMoreDisplayProductsBtn || !displayProductsContainer)
    return;

  showHideLoadMoreDisplayProductsBtn(showMoreDisplayProductsBtn, displayProductsContainer);

  window.onresize = function () { // Kör denna på resize med så blir det lite snyggare
    showHideLoadMoreDisplayProductsBtn(showMoreDisplayProductsBtn, displayProductsContainer);
  };

  showMoreDisplayProductsBtn.addEventListener('click', function () {
    let slickInited = false;

    if (!slickInited) {
      requestAnimationFrame(() => $('.woocommerce-LoopProduct-link.slick-initialized').slick('setPosition'));
      slickInited = true;
    }

    displayProductsContainer.classList.toggle('show-all');
    if (displayProductsContainer.classList.contains('show-all'))
      showMoreDisplayProductsBtn.textContent = showMoreDisplayProductsBtn.dataset.showLessText;
    else
      showMoreDisplayProductsBtn.textContent = showMoreDisplayProductsBtn.dataset.showMoreText;
  });
}

function initLightboxForVariationImages() {
  if (typeof SimpleLightbox === 'undefined')
    return;

  new SimpleLightbox('.single-variation__img a', {
    captionsData: 'alt',
    captionDelay: 150,
    captionPosition: 'bottom',
    widthRatio: HTML_WIDTH >= 768 ? 0.5 : 0.8
  });
}

// ********************************************
// *************** END GENERAL ****************
// ********************************************

// ********************************************
// ************* Mobil och tablet *************
// ********************************************

// function mobileAndTabletFunctionality() {
//   // if (HTML_WIDTH > BREAKPOINT_LARGE)
//   //   return;
// }

// ********************************************
// ********** slut mobil och tablet ***********
// ********************************************

// ********************************************
// ************** DELIVERY PLAN ***************
// ********************************************

function getProductDeliveryPlan() {
  setTimeout(function () {
    $('.single_add_to_cart_button').addClass('disabled');
    toggleProductPageSelects(true);
  }, 200);

  executeGetDeliveryPlanAjax();
}

function executeGetDeliveryPlanAjax() {
  const data = {
    action: 'get_delivery_plan',
    articles: getArticleSkusForDeliveryPlanAjax()
  };

  if (productInformationObj.type === 'variable')
    $('.variations tr').addClass('disabled'); // hindra klick på alla variationsselects

  $.ajax({
    url: ajax_handler.ajaxurl,
    type: 'post',
    dataType: 'json',
    data: data,
    complete: function (response) {
      try {
        JSON.parse(response.responseText);
      } catch (e) {
        console.warn('Invalid JSON in response from get_delivery_plan ajax call');
        return;
      }

      if (productInformationObj.type === 'simple') {
        handleProductDeliveryForSimpleProduct(response);
      } else if (productInformationObj.type === 'variable') {
        handleProductDeliveryForVariableProduct(response);
        toggleProductPageSelects(false);
      } else if (productInformationObj.type === 'bundle') {
        handleProductDeliveryForBundleProduct(response);
        toggleProductPageSelects(false);
      }
    }
  });
}

function handleProductDeliveryForSimpleProduct(response) {
  $.each(JSON.parse(response.responseText), function (_, article) {
    if (article.levdatum == 'BEST' || article.levdatum == '-ST-') {
      $('.out-of-stock-custom-container').html(outOfStock);

      if (isNonStockItem)
        $('.single_add_to_cart_button').removeClass('disabled');
    } else if (typeof article === 'object') {
      if (productInformationObj.noStockItem === '1') {
        $('.single_add_to_cart_button').removeClass('disabled');
        return;
      }

      if (article.in_stock) {
        $('.out-of-stock-custom-container').html('<span>' + productPageTranslations.inStockString + '</span>');
      } else {
        $('.out-of-stock-custom-container').html('<span>' + productPageTranslations.outOfStockAddToCartString + '</span>');
      }

      $('.single_add_to_cart_button').removeClass('disabled');
    }
  });
}

function handleProductDeliveryForVariableProduct(response) {
  const variationStockStatus = [];
  const variationInStock = [];

  $.each(JSON.parse(response.responseText), function (_, article) {
    if (article.levdatum == 'BEST' || article.levdatum == '-ST-') {
      variationStockStatus[article.artnr] = false;
      variationInStock[article.artnr] = false;
    } else {
      variationStockStatus[article.artnr] = true;
      variationInStock[article.artnr] = article.in_stock;
    }
  });

  $('.variations_form').data('levplan', variationStockStatus);
  $('.variations_form').data('in_stock', variationInStock);
  $('.variations tr').removeClass('disabled');

  // Callbacks vi vill köra som hänger på att hämtningen är klar
  triggerChangeIfSizeInQueryParams();
}

function handleProductDeliveryForBundleProduct(response) {
  const variationStockStatus = [];
  const variationInStock = [];

  const allBundleVariationSkus = [];

  for (const bundledItem of Object.values(productInformationObj.bundled_item_products)) {
    if (bundledItem.type === 'variable') {
      for (const variable of bundledItem.variations) {
        allBundleVariationSkus.push(variable.sku);
      }
    } else {
      allBundleVariationSkus.push(bundledItem.sku);
    }
  }

  $.each(JSON.parse(response.responseText), function (_, article) {
    if (typeof article !== 'object')
      return;

    if (allBundleVariationSkus.includes(article.artnr)) {
      if (article.levdatum == 'BEST' || article.levdatum == '-ST-') {
        variationStockStatus[article.artnr] = false;
        variationInStock[article.artnr] = false;
      } else {
        variationStockStatus[article.artnr] = true;
        variationInStock[article.artnr] = article.in_stock;
      }
    }
  });

  $('.bundle_form.cart').data('levplan', variationStockStatus);
  $('.bundle_form.cart').data('in_stock', variationInStock);
  $('.single_add_to_cart_button').removeClass('disabled');

  updateBundleProductsStockHtml();
}

function getArticleSkusForDeliveryPlanAjax() {
  const articlesArray = [];
  // const bundleArticleData = [];

  switch (productInformationObj.type) {
    case 'simple':

      return [{ sku: productInformationObj.sku, amount: '1' }];
    case 'variable':
      for (const variation of productInformationObj.variations) {
        articlesArray.push({ sku: variation.sku, amount: '1' });
      }

      return articlesArray;
    case 'bundle':
      for (const bundleProductKey in productInformationObj.bundled_item_products) {
        const bundleProduct = productInformationObj.bundled_item_products[bundleProductKey];

        if (bundleProduct.type === 'simple') {
          articlesArray.push({ sku: bundleProduct.sku, amount: '1' });
        } else if (bundleProduct.type === 'variable') {
          for (const variation of bundleProduct.variations) {
            articlesArray.push({ sku: variation.sku, amount: '1' });
          }
        }
      }

      return articlesArray;
    default:
      return [];
  }
}

// ********************************************
// ********** SLUT DELIVERY PLAN **************
// ********************************************
